import { BannerSizes } from '@/models/Simulation/Constants'
import {
  DeliveryDevices,
  DeliveryInventories,
} from '@/models/CampaignOperation/Constants'
import { MenuTypes } from './Constants'

export default {
  basicSetting: {
    deliveryDays: 30,
    creativeSetting: {
      bannerSizeCode: [BannerSizes._320x50, BannerSizes._300x250],
    },
    menus: [],
    advertiserList: [],
    hashId: null,
    ownerProfileMenu: {
      id: null,
      name: '',
      creativeType: undefined,
      menuType: MenuTypes.Geo,
      unitType: 'cpc',
      unitPrice: 0,
      costPlusMarginPercentage: 0,
      currency: 'JPY',
    },
  },
  advancedSetting: {
    useAdvancedSetting: false,
    deliveryDevices: [DeliveryDevices.TABLET, DeliveryDevices.PHONE],
    deliveryInventories: [DeliveryInventories.MOBILE_APP],
    onlyJapaneseDevice: false,
    deliveryTimeSchedules: [
      {
        startHour: 0,
        endHour: 23,
      },
    ],
    sex: null,
    marriage: null,
    age: null,
    prefecture: null,
  },
}
